import { createRouter, createWebHistory } from 'vue-router';
const routes = [
    {
        path: '/homePage',
        name: 'homePage',
        component: () => import(/* webpackChunkName: 'Home' */ '../views/homePage/index.vue'),
        meta: {
            // title: '首页',
            showTab: false,
            keepAlive: true
        },
        redirect: '/homeindex',
        children: [
            {
                path: '/homeindex',
                name: 'homeindex',
                component: () => import(
                /* webpackChunkName: 'Home' */ '../views/homePage/homeindex.vue'),
                meta: {
                // title: '首页',
                // showTab: false,
                // keepAlive: true
                }
            }
        ]
    },
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: 'Home' */ '../views/home/index.vue'),
        meta: {
            showTab: false,
            keepAlive: true
        }
    },
    {
        path: '/signin',
        name: 'Signin',
        component: () => import(/* webpackChunkName: 'Signin' */ '../views/login/signin.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/signup',
        name: 'Signup',
        component: () => import(/* webpackChunkName: 'Signup' */ '../views/login/signup.vue'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () => import(/* webpackChunkName: 'Logout' */ '../views/login/logout.vue'),
        meta: {
            title: '登出'
        }
    },
    {
        path: '/clue',
        name: 'Clue',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/login/clue.vue'),
        meta: {
            title: '线索'
        }
    },
    {
        path: '/bindingPhone',
        name: 'BindingPhone',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/login/bindingPhone.vue'),
        meta: {
            title: '绑定手机号'
        }
    },
    {
        path: '/init',
        name: 'Initiate',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/index/index.vue'),
        meta: {
            title: '发起',
            showTab: true
        }
    },
    {
        path: '/step2',
        name: 'Step2',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/step2/step2.vue')
    },
    {
        path: '/step3',
        name: 'Step3',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/step3/step3.vue')
    },
    {
        path: '/step4',
        name: 'Step4',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/step4/step4.vue')
    },
    {
        path: '/step4_enpty',
        name: 'Step4Enpty',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/step4_enpty.vue')
    },
    {
        path: '/step5',
        name: 'Step5',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/step5.vue')
    },
    {
        path: '/step6',
        name: 'Step6',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/step6.vue')
    },
    {
        path: '/bd-step3',
        name: 'bdStep3',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/init/bdStep3.vue')
    },
    {
        path: '/review-patient',
        name: 'ReviewPatient',
        component: () => import(
        /* webpackChunkName: 'Clue' */ '../views/review/reviewPatient/reviewPatient.vue')
    },
    {
        path: '/review-payment',
        name: 'ReviewPayment',
        component: () => import(
        /* webpackChunkName: 'Clue' */ '../views/review/reviewPayment/reviewPayment.vue')
    },
    {
        path: '/review-hold',
        name: 'ReviewHold',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/review/reviewHold.vue')
    },
    {
        path: '/clue-hold',
        name: 'ClueHold',
        component: () => import(/* webpackChunkName: 'Clue' */ '../views/login/clueHold.vue')
    },
    {
        path: '/feed',
        name: 'Feed',
        component: () => import(/* webpackChunkName: 'Feed' */ '../views/review/feed.vue')
    },
    {
        path: '/nx',
        name: 'nx',
        component: () => import(/* webpackChunkName: 'Info' */ '../views/info/index.vue'),
        meta: {
            controlWelcomeLoading: true
        }
    },
    {
        path: '/payment',
        name: 'Payment',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/payment.vue')
    },
    {
        path: '/donate-list',
        name: 'donateList',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/donateList.vue')
    },
    {
        path: '/payment2',
        name: 'Payment2',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/payment2.vue')
    },
    {
        path: '/payment-success',
        name: 'PaymentSuccess',
        component: () => import(
        /* webpackChunkName: 'Payment' */ '../views/info/paymentSuccess.vue')
    },
    {
        path: '/payment-success2',
        name: 'PaymentSuccess2',
        component: () => import(
        /* webpackChunkName: 'Payment' */ '../views/info/paymentSuccess2.vue')
    },
    {
        path: '/paymentSuccess2backups',
        name: 'PaymentSuccess2backups',
        component: () => import(
        /* webpackChunkName: 'Payment' */ '../views/info/paymentSuccess2backups.vue')
    },
    {
        path: '/insurance',
        name: 'Insurance',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/insurance.vue')
    },
    {
        path: '/welcome',
        name: 'welcome',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/welcome.vue')
    },
    {
        path: '/prove',
        name: 'Prove',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/prove.vue')
    },
    {
        path: '/refund',
        name: 'Refund',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/refund.vue')
    },
    {
        path: '/report',
        name: 'Report',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/report.vue')
    },
    {
        path: '/all-thanks',
        name: 'AllThanks',
        component: () => import(/* webpackChunkName: 'Payment' */ '../views/info/allThanks.vue')
    },
    {
        path: '/search-hospital',
        name: 'SearchHospital',
        component: () => import(
        /* webpackChunkName: 'Payment' */ '../views/review/searchHospital.vue')
    },
    {
        path: '/power/svg-icon',
        name: 'SvgIcon',
        component: () => import(
        /* webpackChunkName: 'Payment' */ '../views/init/demo/svgicon.vue'),
        meta: {
            title: '图标组件'
        }
    },
    {
        path: '/users',
        name: 'User',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/index.vue'),
        meta: {
            title: '个人中心',
            showTab: true
        }
    },
    {
        path: '/fund-list',
        name: 'FundList',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/fundList.vue')
    },
    {
        path: '/donate',
        name: 'Donate',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/donate.vue')
    },
    {
        path: '/bd-agent',
        name: 'BdAgent',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/bdAgent.vue')
    },
    {
        path: '/protocol',
        name: 'Protocol',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/protocol.vue')
    },
    {
        path: '/apply-withdrawal',
        name: 'ApplyWithdrawal',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/applyWithdrawal.vue')
    },
    {
        path: '/user-help',
        name: 'userHelp',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/userHelp.vue')
    },
    {
        path: '/withdrawal-list',
        name: 'WithdrawalList',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/withdrawalList.vue')
    },
    {
        path: '/user-st',
        name: 'st',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/st.vue'),
        meta: {
            title: 'setToken'
        }
    },
    {
        path: '/freetoReceive',
        name: 'freetoReceive',
        component: () => import(/* webpackChunkName: 'User' */ '../views/info/freetoReceive.vue')
    },
    {
        path: '/equity',
        name: 'Equity',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/equity.vue')
    },
    {
        path: '/operate',
        name: 'Operate',
        component: () => import(/* webpackChunkName: 'User' */ '../views/user/operate.vue'),
        meta: {
            title: '设置'
        }
    },
    //患者详情页
    {
        path: '/patientdetails',
        name: 'PatientDetails',
        component: () => import(/* webpackChunkName: 'User' */ '../views/info/patientDetails.vue')
    },
    //调查问卷
    {
        path: '/questionnaire',
        name: 'questionnaire',
        component: () => import(
        /* webpackChunkName: 'User' */ '../views/questionnaire/userPatientDetails.vue')
    },
    //调查问卷
    {
        path: '/questionnaireSuccess',
        name: 'questionnaireSuccess',
        component: () => import(
        /* webpackChunkName: 'User' */ '../views/questionnaire/userPatientDetailsSuccess.vue')
    },
    {
        path: '/registration',
        name: 'registration',
        component: () => import(/* webpackChunkName: 'User' */ '../views/registration/index.vue')
    },
    {
        path: '/registrationSe',
        name: 'registrationSe',
        component: () => import(
        /* webpackChunkName: 'User' */ '../views/registration/registration-se.vue')
    },
    {
        path: '/reading-page',
        name: 'readingPage',
        component: () => import(/* webpackChunkName: 'User' */ '../views/readingPage/index.vue')
    },
    {
        path: '/middle',
        name: 'middle',
        component: () => import(/* webpackChunkName: 'User' */ '../views/jumpTo/index.vue')
    },
    {
        path: '/left-to',
        name: 'left-to',
        component: () => import(/* webpackChunkName: 'User' */ '../views/jumpTo/indexOld.vue')
    },
    {
        path: '/info',
        name: 'Info',
        component: () => import(/* webpackChunkName: 'Info' */ '../views/jumpTo/info.vue')
    },
    {
        path: '/donateTogether',
        name: 'donateTogether',
        component: () => import(/* webpackChunkName: 'Info' */ '../views/info/donateTogether.vue')
    },
    {
        path: '/togetherList',
        name: 'togetherList',
        component: () => import(/* webpackChunkName: 'Info' */ '../views/user/togetherList.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        redirect: '/'
    }
];
const router = createRouter({
    history: createWebHistory(),
    routes
});
// 创建一个数组来存储路由历史
const routeHistory = [];
// 使用导航守卫记录路由历史
router.beforeEach((to, from) => {
    if (to.path === '/info' || to.name === 'Info') {
        return { name: 'nx', query: to.query };
    }
    routeHistory.push(from.path);
});
export default router;
export { routeHistory };
